
<div class="page-header">
    <a routerLink="/tags/overzicht" class="page-header__back">
        <i class="fa-regular fa-chevron-left"></i>
    </a>
    <h1 class="page-header__title">{{ "tag.title" | translate }}</h1>
    <div class="page-header__actions"></div>
</div>

<app-tag-detail-form [tag]="tag$ | async" (submitted)="submit($event)" [errors]="errors$ | async" [loading]="loading$ | async"/>
